import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const NotificationToast = ({ message, type = 'info', isVisible, onClose, duration = 3000 }) => {
  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  if (!isVisible) return null;

  const getToastConfig = () => {
    switch (type) {
      case 'success':
        return {
          icon: 'CheckCircle',
          bgColor: 'bg-success/10',
          borderColor: 'border-success/20',
          textColor: 'text-success',
          iconColor: 'var(--color-success)'
        };
      case 'error':
        return {
          icon: 'XCircle',
          bgColor: 'bg-error/10',
          borderColor: 'border-error/20',
          textColor: 'text-error',
          iconColor: 'var(--color-error)'
        };
      case 'warning':
        return {
          icon: 'AlertTriangle',
          bgColor: 'bg-warning/10',
          borderColor: 'border-warning/20',
          textColor: 'text-warning',
          iconColor: 'var(--color-warning)'
        };
      default:
        return {
          icon: 'Info',
          bgColor: 'bg-primary/10',
          borderColor: 'border-primary/20',
          textColor: 'text-primary',
          iconColor: 'var(--color-primary)'
        };
    }
  };

  const config = getToastConfig();

  return (
    <div className="fixed top-20 right-4 z-[300] animate-slide-in-right">
      <div className={`flex items-center gap-3 px-4 py-3 ${config?.bgColor} border ${config?.borderColor} rounded-lg shadow-elevation-md min-w-[300px] max-w-md`}>
        <Icon name={config?.icon} size={20} color={config?.iconColor} />
        <p className={`text-sm font-medium ${config?.textColor} flex-1`}>{message}</p>
        <button
          onClick={onClose}
          className={`${config?.textColor} hover:opacity-70 transition-opacity`}
          aria-label="Close notification"
        >
          <Icon name="X" size={16} />
        </button>
      </div>
    </div>
  );
};

export default NotificationToast;